var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasImage)?_c('img',{ref:"image",attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('SvgIcon',{staticClass:"svg-placeholder",attrs:{"icon":_vm.icons.SvgPlaceholder}})}
var staticRenderFns = []

export { render, staticRenderFns }